<template>
    <asli-page-not-found />
    <asli-divider class="my-[30px]" />
    <div class="text-center md:text-left">
        <asli-button id="error-return-to-homepage" class="mb-[30px]" color="primary" @click="goHome">
            Return to Homepage
        </asli-button>
    </div>
</template>

<script lang="ts" setup>
import { AsliDivider, AsliButton, AsliPageNotFound } from "@mbs-npm/anpost-ui";
import { getResolvedRouteName } from "@/router/utils";
import { ROUTE_NAMES } from "@/router/types";
import { useRouter } from "vue-router";

const router = useRouter();

function goHome() {
    router.push({ name: getResolvedRouteName(ROUTE_NAMES.AboutYou, router.currentRoute.value) });
}
</script>
